import { Box } from "@mui/material";
import { ReactNode } from "react";
import { colors } from "../theme";

const RoundIcon: React.FC<{
  width?: number | string;
  height?: number | string;
  children: ReactNode;
}> = ({ children, width = 40, height = 40 }) => (
  <Box
    sx={{
      width,
      height,
      borderRadius: "50%",
      backgroundColor: colors.violet[200],
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colors.violet[500],
    }}
  >
    {children}
  </Box>
);

export default RoundIcon;
